import { TableRow, TableCell } from "@mui/material";
import { Skeleton } from "@mui/material";

export interface SkeletonRowProps {
  columnNum: number;
}

const SkeletonRow = (props: SkeletonRowProps) => {
  return (
    <TableRow>
      {Array(props.columnNum)
        .fill(0)
        .map((_x, idx) => (
          <TableCell key={idx}>
            <Skeleton />
          </TableCell>
        ))}
    </TableRow>
  );
};

export default SkeletonRow;
